/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Alerts/Warning': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M14.907 12.125c0-.083.056-.139.139-.139h1.911c.083 0 .138.056.138.139l-.235 6.577c0 .097-.041.139-.138.139h-1.44c-.098 0-.14-.042-.14-.139l-.235-6.577zm1.094 7.367c.651 0 1.15.526 1.15 1.136 0 .61-.499 1.135-1.15 1.135-.65 0-1.149-.526-1.149-1.135 0-.61.498-1.136 1.149-1.136zm-8.899 4.166L16 7.984l8.898 15.674H7.102zm20.866 1.61L16.217 4.128a.248.248 0 00-.433 0L4.032 25.268a.247.247 0 00.215.367h23.507a.246.246 0 00.214-.367z"/>'
  }
})
